import { useEffect, useState } from 'react';

import './app.scss'; // Import your CSS file with styles
import { useAuth } from './features/auth/application/authController';
import Navigator from './features/common/application/navigator';


const App = () => {
    const { checkAuthState } = useAuth();
    const [themeMode] = useState<'dark' | 'light'>('dark');

    useEffect(() => {
        const initializeAfterAuth = async () => {
            await checkAuthState();
        };

        initializeAfterAuth();
    }, [checkAuthState]);

    useEffect(() => {
        document.documentElement.style.colorScheme = themeMode;
        globalThis.localStorage?.setItem('themeMode', 'dark');
    }, [themeMode]);

    return (
        <div className={`App ${themeMode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
            {Navigator()}
        </div>
    );
};

export default App;
